import {NavigationGuardNext, Route} from 'vue-router/types/router'
import {useAuth} from '@/plugins/auth'
import {useIntendedRedirect} from '@/core/utils/intendedRedirect'

const authGuard = (to: Route, from: Route, next: NavigationGuardNext): any => {
    const auth = useAuth()

    if (!auth.signed()) {
        useIntendedRedirect().set(to.fullPath)
        next({name: 'login'})
    } else {
        next()
    }
}

export default authGuard
